import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared'
import { supabase } from '@/utils/supabase'

interface AuthUIProps {
  view?: 'sign_in' | 'sign_up' | 'magic_link' | 'forgotten_password'
  redirectTo?: string
}

export default function AuthUI({ view = 'sign_in', redirectTo }: AuthUIProps) {
  return (
    <div className="w-full max-w-md mx-auto">
      <Auth
        supabaseClient={supabase}
        view={view}
        appearance={{
          theme: ThemeSupa,
          variables: {
            default: {
              colors: {
                brand: '#3b82f6',
                brandAccent: '#2563eb',
                brandButtonText: '#ffffff',
                defaultButtonBackground: '#ffffff',
                defaultButtonBackgroundHover: '#f3f4f6',
                defaultButtonBorder: '#d1d5db',
                defaultButtonText: '#374151',
                dividerBackground: '#e5e7eb',
                inputBackground: '#ffffff',
                inputBorder: '#d1d5db',
                inputBorderHover: '#9ca3af',
                inputBorderFocus: '#3b82f6',
                inputText: '#374151',
                inputLabelText: '#6b7280',
                inputPlaceholder: '#9ca3af',
                messageText: '#374151',
                messageTextDanger: '#dc2626',
                anchorTextColor: '#3b82f6',
                anchorTextHoverColor: '#2563eb',
              },
              space: {
                inputPadding: '12px 16px',
                buttonPadding: '12px 16px',
              },
              fontSizes: {
                baseBodySize: '14px',
                baseInputSize: '14px',
                baseLabelSize: '14px',
                baseButtonSize: '14px',
              },
              fonts: {
                bodyFontFamily: 'Inter, system-ui, sans-serif',
                buttonFontFamily: 'Inter, system-ui, sans-serif',
                inputFontFamily: 'Inter, system-ui, sans-serif',
                labelFontFamily: 'Inter, system-ui, sans-serif',
              },
              borderWidths: {
                buttonBorderWidth: '1px',
                inputBorderWidth: '1px',
              },
              radii: {
                borderRadiusButton: '8px',
                buttonBorderRadius: '8px',
                inputBorderRadius: '8px',
              },
            },
          },
        }}
        providers={['google', 'github']}
        redirectTo={redirectTo || `${window.location.origin}/dashboard`}
        showLinks={true}
        magicLink={true}
        localization={{
          variables: {
            sign_in: {
              email_label: 'Email address',
              password_label: 'Password',
              button_label: 'Sign in',
              loading_button_label: 'Signing in...',
              social_provider_text: 'Sign in with {{provider}}',
              link_text: 'Already have an account? Sign in',
            },
            sign_up: {
              email_label: 'Email address',
              password_label: 'Password',
              button_label: 'Create account',
              loading_button_label: 'Creating account...',
              social_provider_text: 'Sign up with {{provider}}',
              link_text: "Don't have an account? Sign up",
            },
            forgotten_password: {
              email_label: 'Email address',
              password_label: 'Password',
              button_label: 'Send reset instructions',
              loading_button_label: 'Sending...',
              link_text: 'Forgot your password?',
              confirmation_text: 'Check your email for the password reset link',
            },
            magic_link: {
              email_input_label: 'Email address',
              email_input_placeholder: 'your@email.com',
              button_label: 'Send magic link',
              loading_button_label: 'Sending...',
              link_text: 'Send a magic link email',
              confirmation_text: 'Check your email for the magic link',
            },
          },
        }}
      />
    </div>
  )
} 